module.exports = __webpack_public_path__ + "img/305.23b5a54f.png";